"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _components = require("../../../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const mapStateToProps = state => ({
  auth: state.auth,
  invitations: state.invitations
});
class PostSignUp extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      auth,
      invitations
    } = this.props;
    if (auth.postSignUpConfig.enabled !== undefined && auth.postSignUpConfig.enabled === false) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        to: '/sign-in'
      });
    } else if (auth.postSignUpConfig.customOverridePath !== undefined && auth.postSignUpConfig.customOverridePath !== '') {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        to: auth.postSignUpConfig.customOverridePath
      });
    } else {
      let showWarning = false;
      let downloadLink = auth.postSignUpConfig.downloadLink;
      showWarning = invitations.single.data.CanAlterEmail;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flexFlow: 'column',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'container-fluid justify-content-left mt-5'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-narrow"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'd-flex mb-4'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: 'page-title ml-0'
      }, " ")), /*#__PURE__*/_react.default.createElement("div", {
        className: "card rounded shadow mb-3 p-5"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'alert alert-success fade show',
        style: {
          color: '#000000'
        }
      }, "Well done! Account successfully created."), /*#__PURE__*/_react.default.createElement("div", null, showWarning && /*#__PURE__*/_react.default.createElement("div", {
        className: 'alert alert-warning fade show',
        style: {
          color: '#000000'
        }
      }, "Please check your inbox and verify your email."), /*#__PURE__*/_react.default.createElement("div", {
        className: 'd-flex mt-5 mb-3'
      }, !downloadLink && /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary mr-4",
        disabled: true
      }, "App not available"), downloadLink && /*#__PURE__*/_react.default.createElement("a", {
        href: downloadLink
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary mr-4"
      }, "Download App")), /*#__PURE__*/_react.default.createElement("a", {
        href: "/sign-in"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary mr-4"
      }, "Go to login"))))))), /*#__PURE__*/_react.default.createElement(_components.ImprintLink, null));
    }
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(PostSignUp);
module.exports = exports.default;